"use client";
import { observer } from "../../service/mobx";
import { useTrackView } from "../../component/Hooks";

function Hooks() {
  useTrackView("Feed");
}

export default observer(Hooks);
